import {
    Modal,
    Row,
    Spacer,
    Text,
    Title,
} from '@components/1-atoms';
import React, { FC, useEffect, useState } from 'react';

import {
    Button,
    IconButton
} from '@components/2-molecules';

import ContactList from '@components/3-organisms/Lists/ListContact';

import EditIcon from '@assets/icons/edit';



import { ListItemData } from '@/components/2-molecules/ListItem';
import Add from '@assets/icons/plus';
import Pane from '@components/1-atoms/Pane';
import { css } from '@emotion/native';
import { ScrollView, View } from 'react-native'; // Import View for the flex container
import ViewContact from './ContactView';

type Props = {
    label?: string;
    defaultValue?: any;
    data: Array<any>;
    onChange?: (value: null | any) => void;
    navigation: any;
};

const ContactInput: FC<Props> = ({
    label,
    data,
    defaultValue,
    onChange,
    navigation,
    ...props
}) => {

    const [contact, setContact] = useState(defaultValue);

    const [isModalVisible, setModalVisiblility] = useState(false);
    const openModal = () => setModalVisiblility(true);
    const closeModal = () => setModalVisiblility(false);

    useEffect(() => { onChange?.(contact); }, [contact]);

    useEffect(() => { setContact(defaultValue) }, [defaultValue]);

    const _navigateToContactCreatePage = () => navigation.navigate('ContactCreate');


    const _onPressLisitem = (value: ListItemData) => {
        if (value?.id === contact?.id) {
            setContact(null);
        } else {
            setContact(value);
        }
        closeModal();
    };

    return (
        <Pane
            inset
        >
            <Row>
                <Title large bold>{'CONTACT'}</Title>
                {contact && <IconButton icon={<EditIcon />} onPress={openModal} />}
            </Row>

            {!contact ?
                <Button
                    inset
                    bg={"transparent"}
                    align={'left'}
                    color={"#434BFF"}
                    right={<Add stroke="#434BFF" />}
                    onPress={openModal}
                    {...props}
                >
                    {label}
                </Button>
                :
                <ViewContact defaultValue={contact} />
            }

            <Modal visible={isModalVisible}>
                {/* Custom modal header - fixed at the top */}
                <Row style={css`align-items: center;`}>
                    <Spacer h={1} />
                    <Text large bold>{label}</Text>
                    <Button
                        bg="transparent"
                        color="#434BFF"
                        onPress={_navigateToContactCreatePage}
                        fullwidth={false}
                        {...props}
                    >
                        New
                    </Button>
                    <Spacer h={1} />
                </Row>

                {/* Scrollable List of contacts - takes most of the height */}
                <ScrollView style={{ flex: 1 }}>
                    <ContactList inset data={data} /* defaultValue={contact} */ onPress={_onPressLisitem} />
                </ScrollView>

                {/* Custom button to close modal - fixed at the bottom */}
                <View>
                    <Spacer h={1} />
                    <Button inset outlined onPress={closeModal}>CANCEL</Button>
                    <Spacer h={2} />
                </View>
            </Modal>
        </Pane>
    )

};

export default ContactInput;
